import React, { useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog, IconButton,
    Paper, Radio, TextField, FormControlLabel, RadioGroup, Box, Grid,
    Button, MenuItem, FormControl, InputLabel, Select,
    Checkbox,
    Typography,
    Tooltip,
    Card
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios'
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Snackbar from '@mui/material/Snackbar';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput } from '../../reusableComponent/ErpTextField';
import { addUnit, editDeleteUnit } from '../../../actions/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import styles from '.././../../styles.module.css';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';

function UnitAdd(props) {
    const dispatch = useDispatch()
    const { handleSubmit } = useForm();
    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    // const editInfo = props.details;
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let navigate = useNavigate();
    const location = useLocation();
    const editData = editInfo.id && editInfo;
    const editid = editData && editData.id;
    const [successMessage, setSuccessMessage] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [openSnak, setOpenSnak] = React.useState(false);

    const [data, setData] = useState({
        id: editid,
        unitName: editData ? editData.unitName : '',
    });

    const date_ob = new Date();
    const hours = date_ob.getHours();
    const minutes = date_ob.getMinutes();
    const seconds = date_ob.getSeconds();
    const milliseconds = date_ob.getMilliseconds();
    const currentTime = hours + ":" + minutes + ":" + seconds + ":" + milliseconds;
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISODateTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (editData) {
            if (reason !== 'backdropClick') {
                setOpen(false);
            }
        } else {
            if (data.unitName == '') {
                setOpen(false);
                setOpenSnak(false);
            } else {
                setOpenSnak(true)
            }
        }
    };

    const handleOpenSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setData({
            unitName: '',
        })
        setOpenSnak(false);
        setOpen(false);
    }

    const handleCloseSnak = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnak(false);
    };

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }


    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.unit.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Unit name already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);
    const clearInputFields = () => {
        setData({
            unitName: '',
        });
    };
    const onSubmit = (event) => {
        const unitData = {
            companyId: userInfo.companyId,
            ...data,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
        }
        if (editData) {
            dispatch(editDeleteUnit(unitData));
        } else {
            dispatch(addUnit(unitData));
        }
        // props.onAPISubmt();
        // props.handleCloseDialog();
    }

    const action = (
        <React.Fragment>
            <Button size="small" id="btnYes" onClick={handleOpenSnack}>
                Yes
            </Button>
            <Button size="small" id="btnNo" onClick={handleCloseSnak}>
                No
            </Button>
        </React.Fragment>
    );


    return (
        <>
            <Breadcrumb
                routeSegments={[
                    { name: 'Masters', path: '/masters/' },
                    { name: 'Unit List', path: '/masters/unit-masters' },
                    { name: 'Create Unit' },
                ]}
            />
            <div>
                <Paper className={`${styles.list_container}`}>

                    <Box sx={{ m: 4 }} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box >
                            <Grid container spacing={2} style={{ minHeight: '350px', paddingLeft: '50px' }}>
                                <Grid item xs={4} >
                                    <Typography> Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} ></Grid>
                                <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                    <Card className={`${styles.m_card}`}>
                                        <Grid container spacing={2} >
                                            <Grid item xs={3}>
                                                <Typography className={`${styles.erp_lable}`}>Unit Name</Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <ERPinput
                                                    fullWidth
                                                    size='small'
                                                    name="unitName"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.unitName)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Box sx={{ marginTop: '12px', float: 'right' }}>
                                            <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                                <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} /> {editData ? 'Update' : 'Save'}
                                            </Button>
                                            <Cancel />
                                        </Box>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Paper>
                <Snackbar
                    open={openSnak}
                    autoHideDuration={4000}
                    onClose={handleCloseSnak}
                    message="Do you wish to close without saving ?"
                    action={action}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                />
            </div>
            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage}
                    autoHideDuration={2000}
                    message={successMessage}
                />
            }
        </>
    )
}

export default UnitAdd